import { databaseAttachmentFilterFunctions } from '@streamlain/database-identity';

import { t } from '../../logical/type-presets.js';
import { createFilter } from './create.js';

export const attachmentFilter = [
  createFilter({
    name: 'isEmpty',
    self: t.attachment.instance(),
    args: [] as const,
    label: 'Is empty',
    shortString: () => ': Is empty',
    impl: databaseAttachmentFilterFunctions.isEmpty,
  }),
  createFilter({
    name: 'isNotEmpty',
    self: t.attachment.instance(),
    args: [] as const,
    label: 'Is not empty',
    shortString: () => ': Is not empty',
    impl: databaseAttachmentFilterFunctions.isNotEmpty,
  }),
  createFilter({
    name: 'filenameContains',
    self: t.attachment.instance(),
    args: [t.string.instance()] as const,
    label: 'Filename contains',
    shortString: v => (v ? `: Filename contains ${v.value}` : undefined),
    impl: databaseAttachmentFilterFunctions.filenameContains,
  }),
  createFilter({
    name: 'mimeStartsWith',
    self: t.attachment.instance(),
    args: [t.string.instance()] as const,
    label: 'MIME starts with',
    shortString: v => (v ? `: MIME starts with ${v.value}` : undefined),
    impl: databaseAttachmentFilterFunctions.mimeStartsWith,
  }),
  createFilter({
    name: 'countEqual',
    self: t.attachment.instance(),
    args: [t.number.instance()] as const,
    label: 'File count =',
    shortString: v => (v ? `: Count = ${v.value}` : undefined),
    impl: databaseAttachmentFilterFunctions.countEqual,
  }),
  createFilter({
    name: 'countNotEqual',
    self: t.attachment.instance(),
    args: [t.number.instance()] as const,
    label: 'File count !=',
    shortString: v => (v ? `: Count != ${v.value}` : undefined),
    impl: databaseAttachmentFilterFunctions.countNotEqual,
  }),
  createFilter({
    name: 'countGreaterThan',
    self: t.attachment.instance(),
    args: [t.number.instance()] as const,
    label: 'File count >',
    shortString: v => (v ? `: Count > ${v.value}` : undefined),
    impl: databaseAttachmentFilterFunctions.countGreaterThan,
  }),
  createFilter({
    name: 'countGreaterThanOrEqual',
    self: t.attachment.instance(),
    args: [t.number.instance()] as const,
    label: 'File count >=',
    shortString: v => (v ? `: Count >= ${v.value}` : undefined),
    impl: databaseAttachmentFilterFunctions.countGreaterThanOrEqual,
  }),
  createFilter({
    name: 'countLessThan',
    self: t.attachment.instance(),
    args: [t.number.instance()] as const,
    label: 'File count <',
    shortString: v => (v ? `: Count < ${v.value}` : undefined),
    impl: databaseAttachmentFilterFunctions.countLessThan,
  }),
  createFilter({
    name: 'countLessThanOrEqual',
    self: t.attachment.instance(),
    args: [t.number.instance()] as const,
    label: 'File count <=',
    shortString: v => (v ? `: Count <= ${v.value}` : undefined),
    impl: databaseAttachmentFilterFunctions.countLessThanOrEqual,
  }),
];
